"use strict";

const commonEventProperties = ['pageName', 'pageSection', 'pageStage', 'pageDept', 'pageSegmentation'];
module.exports = {
  commonEventProperties
};